import React from "react";
import { FaTimes } from "react-icons/fa";

const DeleteConformation = ({ ismodal, setIsmodal, fun,data}) => {
  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-md w-[90%] max-w-md p-6 relative">
        {/* Close Icon */}
        <button
          className="absolute top-3 right-3 text-gray-600 hover:text-black"
          onClick={() => setIsmodal(false)}
        >
          <FaTimes />
        </button>

        {/* Content */}
        <div className="text-center">
   <p className="text-lg font-semibold mb-6">
  Are you sure you want to delete the record of <span className="text-red-600 font-bold">{data?.firstname}</span>?
</p>

          <div className="flex justify-center gap-4">
            <button
              onClick={() => setIsmodal(false)}
              className="px-4 py-2 rounded bg-gray-300 text-black hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                fun();
           
              }}
              className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConformation;
